import legalEntityForm from "@/core/services/forms/legalEntityForm.js";
import { INIT_FORM } from "@/core/services/store/form.module.js";

export default {
  methods: {
    /**
     * Init entity form with empty fields and open legal entity form modal
     * @param {Object} fields
     * @return {void}
     */
    createLegalEntity(fields = null) {
      let form = JSON.parse(JSON.stringify(legalEntityForm));
      if (fields) {
        for (const [key, value] of Object.entries(fields)) {
          form.fields[key] = value;
        }
      }
      this.$store.dispatch(INIT_FORM, form);
      if (this.$refs.legalEntityFormModal) {
        this.$refs.legalEntityFormModal.show();
      }
    },

    /**
     * Init client form with edit mode and open client form element
     * @param {Object} client
     * @return {void}
     */
    editLegalEntity(entity) {
      let form = JSON.parse(JSON.stringify(legalEntityForm));
      form.mode = "edit";
      form.path = form.path + "/" + entity.id;
      for (const [key, value] of Object.entries(entity)) {
        form.fields[key] = value;
      }
      form.fields._method = "PUT";
      form.helpers.notificationsSentBy =
        this.updateEntityBookingNotifications(entity);
      form.helpers.legalForm = form.fields.legalForm;
      this.$store.dispatch(INIT_FORM, form);
      if (this.$refs.legalEntityFormModal) {
        this.$refs.legalEntityFormModal.show();
      }
    },

    /**
     * Update form booking notification field
     * @param {Object} entity
     * @return {string}
     */
    updateEntityBookingNotifications(entity) {
      return entity.bookingNotificationsEnabled == true ? "email" : "dont_send";
    },
  },
};
